import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../res/betterhusband_black.png';

const NotFound = () => {
  return (
    <div className="bg-white flex flex-col pb-safe">
      {/* Navigation */}
      <nav className="px-6 py-4 border-b border-stone-200">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} alt="Better Husband" className="w-8 h-8 object-contain" />
            <span className="font-serif text-xl font-medium text-stone-900">Better Husband</span>
          </Link>
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md mx-auto text-center">
          {/* 404 Number */}
          <div className="mb-8">
            <h1 className="font-serif text-8xl md:text-9xl font-light text-stone-300 mb-4">404</h1>
          </div>

          {/* Message */}
          <div className="mb-8">
            <h2 className="font-serif text-3xl md:text-4xl font-normal text-stone-900 mb-4">
              Page not found
            </h2>
            <p className="text-lg text-stone-600 leading-relaxed">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          {/* Actions */}
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-stone-900 text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-stone-800 transition-all hover:-translate-y-0.5 w-full sm:w-auto"
            >
              Go Home
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            </Link>

            <div className="text-center">
              <p className="text-stone-500 text-sm">
                Or try one of these pages:
              </p>
              <div className="flex flex-wrap justify-center gap-4 mt-4">
                <Link to="/dashboard" className="text-stone-600 hover:text-stone-900 transition-colors text-sm underline">
                  Dashboard
                </Link>
                <Link to="/landing" className="text-stone-600 hover:text-stone-900 transition-colors text-sm underline">
                  Landing
                </Link>
                <Link to="/support" className="text-stone-600 hover:text-stone-900 transition-colors text-sm underline">
                  Support
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-6 bg-[#faf9f7] border-t border-stone-200">
        <div className="max-w-6xl mx-auto text-center">
          <p className="font-serif text-lg text-stone-900 mb-2">Better Husband</p>
          <p className="text-xs text-stone-400">2026 Better Husband. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default NotFound;